import { createGlobalStyle } from "styled-components";

/* 구글 저작권 + 로고 + 단축키 + 약관 제거 */

export const GoogleMapGlobalStyle = createGlobalStyle`
    .gm-style-cc,
    .gmnoprint,
    .gmnoscreen {
        display: none !important;
    }

    a[href^="https://maps.google.com/maps"],
    a[href^="https://maps.google.com/maps"] img {
        display: none !important;
    }
`;
